module.exports = __webpack_public_path__ + "static/timanttiristi2.b09cc7f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/timanttiristi2.jpg
// module id = 856
// module chunks = 35783957827783